import * as types from './actionTypes';
import mySucessDetailApi from '../api/mySucessDetailApi';

export function getMySucessDetail(period,person, user) {
  return function (dispatch) {
    return dispatch({type: types.LOAD_MY_SUCESS_DETAIL, payload: mySucessDetailApi.getMySucessDetailApi(period,person, user)});
  };
}
